import { ScheduleModel } from '../types/general.types';

export const generateNewSchedule = (): Partial<ScheduleModel> => ({
  dayOfWeek: 'MONDAY',
  startHour: '19:00',
  endHour: '19:00',
});
